package com.eladfinish.bible.contest.features.hebrewCalendar

import com.eladfinish.bible.contest.SharedRes
import com.eladfinish.bible.contest.chumash
import com.eladfinish.bible.contest.constants.Constants
import com.eladfinish.bible.contest.data.common.stringResolver.StringResolver
import com.eladfinish.bible.contest.domain.BooksRepository.bookNamesHebrew
import com.eladfinish.bible.contest.entities.Parashot
import com.eladfinish.bible.contest.extensions.replaceRegex
import com.eladfinish.bible.contest.parasha_not_found
import com.eladfinish.bible.contest.parashat_hashavua
import com.eladfinish.bible.contest.screens.browse.tableOfContents.model.ChapterOrParashaOrSederData
import com.eladfinish.bible.contest.utils.GetParashotUseCase
import com.eladfinish.bible.contest.utils.makeVavAndYudOptional
import com.russhwolf.settings.Settings
import dev.icerock.moko.resources.desc.Raw
import dev.icerock.moko.resources.desc.StringDesc
import dev.icerock.moko.resources.desc.desc
import io.github.aakira.napier.Napier
import sternbach.software.kosherkotlin.hebrewcalendar.JewishCalendar

class GetCurrentParashaUseCase(
    private val settings: Settings,
    private val getParashotUseCase: GetParashotUseCase,
    private val stringResolver: StringResolver, // TODO: try to get rid of StringResolver
) {

    private val week by lazy { settings.getInt(Constants.PREF_MY_TESTING_WEEK, 0) }

    private fun parseParashot(bookNumber: Int, connected: Boolean = true): Parashot {
        require(bookNumber in 1..5) {
            "book must be in range 1...5"
        }
        return getParashotUseCase.parseParashot(bookNumber = bookNumber, connected = connected)
    }

    operator fun invoke(): ChapterOrParashaOrSederData {
        var str = ""
        Napier.d("MainActivity_week: $week")
        val currentParasha = stringResolver.resolveString(getCurrentParasha(week = week))
        var pickedBookHeb = ""
        var position = -1
        var indexPickedChumash = 0
        for (bookNumber in 1..5) {
            indexPickedChumash = bookNumber - 1
            val parashotArrayList = parseParashot(bookNumber).parashotNames
            position = parashotArrayList.indexOfFirst {
                currentParasha.matches(it.makeVavAndYudOptional().replaceRegex(regex = " -", replacement = "").toRegex())
            }
            if (position != -1) {
                Napier.d("פרשת השבוע לפי ספריית זמנים: $currentParasha")
                Napier.d("פרשת השבוע לפי הכיתוב באפליקציה: ${parashotArrayList[position]}")
                Napier.d("indexPickedBook: $bookNumber")
                Napier.d("position: $position")
                str = parashotArrayList[position]
                pickedBookHeb = bookNamesHebrew[bookNumber - 1]
                break
            }
        }
        Napier.d("showCurrentParasha - position: $position")
        if (position == -1) {
            str = currentParasha
        }

//        buttonCurrentParasha.setOnClickListener {
//            if (position == -1) {
//                Napier.d(
//                    """
//                        ${stringResolver.resolveString(SharedRes.strings.parasha_not_found.desc())}
//                        $currentParasha
//                        """.trimIndent()
//                )
//                requireContext().toast("בהמשך תהיה אפשרות לצפות בקריאות של חגים") todo: add this sentence
//                return@setOnClickListener
//            }
        Napier.d(
            "parashat hashavua: ${stringResolver.resolveString(SharedRes.strings.chumash.desc())} $pickedBookHeb $indexPickedChumash" +
                    "\n${stringResolver.resolveString(SharedRes.strings.parashat_hashavua.desc())} $currentParasha $position"
        )

        return ChapterOrParashaOrSederData(
            name = StringDesc.Raw(str),
            bookIndex = indexPickedChumash,
            partIndex = position,
        )
    }

    private fun getCurrentParasha(
        week: Int,
    ): StringDesc {
        val upcoming = ParashaCalendar.upcoming(
            today = JewishCalendar().gregorianLocalDate,
            week = week,
        )
        // Either the parasha's name or, with no parasha that Shabbat, the holiday's name
        return StringDesc.Raw(upcoming.name)
    }
}
